import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { throwApiError } from "../errorHandler";
import { UserPreferences } from "../../types/userPreferences";

/**
 * Fetch user preferences from Collins API.
 * Returns null when the user has no saved preferences (404),
 * allowing the caller to fall back to defaults.
 * Throws on other failures.
 * @param userId - The DMN user _id (MongoDB ObjectId) to fetch preferences for.
 */
export const fetchUserPreferences = async (
  userId: string
): Promise<UserPreferences | null> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  if (!userId) {
    throw new Error("Unable to resolve user ID");
  }

  const response = await fetch(
    `${environmentVars?.COLLINS_API_BASE_URL}/users/${userId}/preferences`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    }
  );

  if (response.status === 404) {
    return null;
  }

  if (!response.ok) {
    await throwApiError(response, "Error fetching user preferences");
  }

  return await response.json();
};
